export default class Tabs {
    constructor(element) {
        this.element = element;

        let $tabsNavItems = $(this.element).find('[data-tabs-nav-item]');
        $tabsNavItems.each((event, element) => {
            element.addEventListener('click', e => {
                e.preventDefault();
                this.switchTabs(this.getTabName(element));
            });
        });

        let tabsSelect = $(this.element).find('[data-tabs-nav-select]')[0];
        tabsSelect.addEventListener('change', e => {
            this.switchTabs(e.target.value);
        });
    }

    getTabName(tab) {
        return $(tab).attr('data-tabs-nav-item-name');
    }

    hideAllTabs() {
        let tabs = $(this.element).find('[data-tab]');
        tabs.attr('data-hidden', true);
    }

    showTab(tabName) {
        let $tab = $(this.element).find('[data-tab-name=' + tabName + ']');
        $tab.removeAttr('data-hidden');
    }

    switchTabs(tabName) {
        this.hideAllTabs();
        this.showTab(tabName);
        this.updateNav(tabName);
        this.updateSelect(tabName);
    }

    updateNav(tabName) {
        let $tabsNavItems = $(this.element).find('[data-tabs-nav-item]');
        $tabsNavItems.removeAttr('data-selected');
        $tabsNavItems
            .filter('[data-tabs-nav-item-name=' + tabName + ']')
            .attr('data-selected', true);
    }

    updateSelect(tabName) {
        let $tabsSelect = $(this.element).find('[data-tabs-nav-select]');
        $tabsSelect.val(tabName);
    }
}



// WEBPACK FOOTER //
// ./js/marketing/components/tabs.js